import { Button, IconButton, Tooltip } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import VisibilityIcon from '@material-ui/icons/Visibility';
import React from 'react';
import { Box } from '../../UI';
import { Link } from 'react-router-dom';
import PublishIcon from '@material-ui/icons/Publish';
import InfoIcon from '@material-ui/icons/Info';
import { display } from '@material-ui/system';

export default function ActionButtons({ data }) {
	return (
		<Box>
			<ExpansionPanel>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography variant="h6"><strong>Actions</strong></Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<Box width="100%">
						{data.sell.digitalId === 100 &&
							<Box display="flex" alignItems="center">
								<Box flexGrow={1}>
									<Typography variant="body1">Blast</Typography>
								</Box>
								<Box>
									<Button
										style={{ width: '193.22px' }}
										variant="contained"
										color="primary"
										startIcon={<PlayCircleFilledIcon />}
									>
										Blast
								</Button>
								</Box>
							</Box>
						}
						<Box display="flex" alignItems="center" width="100%" pt="15px">
							<Box flexGrow={1}>
								<Typography variant="body1">Teaser</Typography>
							</Box>
							<Box display='flex'>
								<Button
									style={{ marginRight: '15px' }}
									variant="contained"
									startIcon={<VisibilityIcon />}
								>
									View
								</Button>
								<div>
									<input
										color="primary"
										accept="image/*"
										type="file"
										onChange={false}
										id="icon-button-file"
										style={{ display: 'none' }}
									/>
									<label htmlFor="icon-button-file">
										<Button variant="contained" startIcon={<EditIcon />} component="span">
											Edit
										</Button>
									</label>
								</div>
							</Box>
						</Box>
						<Box display="flex" alignItems="center" width="100%" pt="15px">
							<Box flexGrow={1}>
								<Typography variant="body1">IM</Typography>
							</Box>
							<Box display='flex'> 
								<Button
									style={{ marginRight: '15px' }}
									variant="contained"
									startIcon={<VisibilityIcon />}
								>
									View
								</Button>
								<div>
									<input
										color="primary"
										accept="image/*"
										type="file"
										onChange={false}
										id="icon-button-file"
										style={{ display: 'none' }}
									/>
									<label htmlFor="icon-button-file">
										<Button variant="contained" startIcon={<EditIcon />} component="span">
											Edit
										</Button>
									</label>
								</div>
							</Box>
						</Box>
						<Box display="flex" alignItems="center" width="100%" pt="15px">
							<Box flexGrow={1}>
								<Typography variant="body1">Process Setting</Typography>
							</Box>
							<Box>
								<Button
									style={{ marginRight: '15px' }}
									variant="contained"
									startIcon={<VisibilityIcon />}
									component={Link}
									to={`/my-portfolio/${data.id}/process-setting`}
								>
									View
								</Button>
								<Button variant="contained" startIcon={<EditIcon />}>
									Edit
								</Button>
							</Box>
						</Box>
						<Box display="flex" alignItems="center" width="100%" pt="15px">
							<Box flexGrow={1} display='flex' alignItems='center'>
								<Typography variant="body1">Legal Documents</Typography>
								<Tooltip title="Legal documents including title/ownership extract and plot/cadastral map extract" aria-label="info">
									<IconButton color="inherit" aria-label="menu">
										<InfoIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</Box>
							<Box>
								<div>
									<input
										color="primary"
										accept="image/*"
										type="file"
										onChange={false}
										id="icon-button-file"
										style={{ display: 'none' }}
									/>
									<label htmlFor="icon-button-file">
										<Button
											style={{ width: '193.22px' }}
											variant="contained"
											color="default"
											component="span"
											startIcon={<PublishIcon />}
										>
											Upload
										</Button>
									</label>
								</div>
							</Box>
						</Box>
					</Box>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</Box>
	);
}
